export const WindowToken = 'Window'; // eslint-disable-line @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match

export function getWindow() {
    return window;
}
